import { render, staticRenderFns } from "./GeocodingUlItem.vue?vue&type=template&id=273d2201&scoped=true"
import script from "./GeocodingUlItem.vue?vue&type=script&lang=js"
export * from "./GeocodingUlItem.vue?vue&type=script&lang=js"
import style0 from "./GeocodingUlItem.vue?vue&type=style&index=0&id=273d2201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d2201",
  null
  
)

export default component.exports